import React, { useState } from 'react';
import { Plus, Phone } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/accordion';
import { faqs, company } from '../data/content';

export default function Faq() {
  return (
    <section id="faq" className="py-20 md:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-5 sm:px-8">
        <div className="text-center">
          <span className="crown-divider text-[#B8892A]">FAQ</span>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0B1E44] leading-tight">
            Häufige Fragen.
          </h2>
          <p className="mt-4 text-slate-600 text-lg">
            Noch etwas offen? Rufen Sie uns einfach an – wir beraten unverbindlich.
          </p>
          <a href={`tel:${company.phoneRaw}`} className="mt-6 inline-flex items-center gap-2 text-[#DC2626] font-bold text-lg hover:text-[#B91C1C] transition-colors">
            <Phone className="w-5 h-5" /> {company.phone}
          </a>
        </div>

        <div className="mt-12">
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((f, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-[#FAF7F2] rounded-xl border border-slate-100 px-5 data-[state=open]:border-[#E0A72C]/60 transition-colors">
                <AccordionTrigger className="text-left font-semibold text-[#0B1E44] hover:no-underline py-5 text-base md:text-lg">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-700 leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
}
